import {TradeType} from 'app/console-api';
import {DealTradeTypes} from 'app/components/common/deal-trade-type/deal-trade-type-meta';
import {BodyText, FlexColumn} from '@make-software/cspr-design';
import React from 'react';

export const DealTradeInfoSnippet= (props: { dealType: TradeType }) => {
    const dealTypeData = DealTradeTypes.find(one => one.key === props.dealType);

    return (
      <FlexColumn>
        <BodyText size={1}>{dealTypeData?.name}</BodyText>
        <BodyText size={2} scale={'xs'} variation={'darkGray'}>{dealTypeData?.dealRequestDescription}</BodyText>
      </FlexColumn>
    );
}